export default "__VITE_ASSET__CJPicmr6__"